import { React, useState } from 'react';
import {
  Label,
  TextInput,
  Flowbite,
  Button,
  Checkbox,
  Modal,
  Alert,
  FileInput,
} from 'flowbite-react';
import { buttonTheme } from '../components/themes';
import { loginUser } from '../firebase/FirebaseManagement';
import { HiInformationCircle } from 'react-icons/hi';
import { useNavigate } from 'react-router';
import { Store } from 'react-notifications-component';
import Footer from '../components/Footer';

export default function () {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [showAlertError, setShowAlertError] = useState(false);
  const navigate = useNavigate();
  const login = async (e) => {
    e.preventDefault();
    try {
      const userCreds = await loginUser(userName, password);
      if (userCreds) {
        //   Set the local Storage
        localStorage.setItem('userId', userCreds.user.uid);
        localStorage.setItem('accessToken', userCreds.user.accessToken);
        localStorage.setItem('isSignedIn', true);
        Store.addNotification({
          title: 'Login',
          message: 'You have successfully logged in!',
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 5000,
            showIcon: true,
          },
        });
        navigate('/myrides');
      } else {
      }
    } catch (error) {
      setShowAlertError(true);
    }
  };
  return (
    <>
      <div className="box-container flex flex-col items-center md:w-[500px] justify-center md:mt-20 mx-auto">
        {showAlertError && (
          <Alert
            color="failure"
            onDismiss={() => setShowAlertError(false)}
            icon={HiInformationCircle}
          >
            <span>
              <p>Your email or password are incorrect. Please try again.</p>
            </span>
          </Alert>
        )}

        <h1 className="text-3xl font-bold">Log in</h1>

        <form onSubmit={login} className="flex flex-col gap-[20px] mt-1">
          <div>
            <Label value="Email"></Label>
            <TextInput
              type="email"
              id="email"
              shadow="true"
              onChange={(e) => setUserName(e.target.value)}
            ></TextInput>
          </div>
          <div>
            <Label value="Password"></Label>
            <TextInput
              type="password"
              id="password"
              shadow="true"
              onChange={(e) => setPassword(e.target.value)}
            ></TextInput>
          </div>
          <p className="text-sm font-medium text-gray-900 dark:text-white">
            Don't have an account?{' '}
            <a href="./signup" className="underline">
              Create one for free
            </a>
          </p>
          <Flowbite theme={{ theme: buttonTheme }}>
            <Button color="primary" className="w-full" type="submit">
              Log in
            </Button>
          </Flowbite>
        </form>
        <Footer />
      </div>
      
    </>
  );
}
